import Vue from 'vue'

import arrow from './components/onboarding/arrow.vue'
import assignUsersHours from './components/AssignHours/AssignHours'
import Buy from './components/Buy.vue'
import ColorPicker from './components/Subjects/ColorPicker'
import copyCalendar from './components/CopyCalendar/CopyCalendar.vue'
import CreateKlasses from './components/CreateCalendars/CreateKlasses/CreateKlasses'
import CreateRoomsButton from './components/CreateCalendars/CreateRoomsButton'
import CreateUsers from './components/CreateCalendars/CreateUser/CreateUser'
import CreateUsersButton from './components/CreateCalendars/CreateUser/CreateUserButton'
import CreateUsersButtonROR from './components/CreateCalendars/CreateUser/CreateUserButtonROR'
import DeleteDayOrWeek from './components/DeleteDayOrWeek.vue'
import deleteUserSettings from './components/onboarding/DeleteUserSettings'
import DirectDaySelector from './components/VacationDaysSelector/DirectDaySelector.vue'
import DropUp from './components/common/DropUp.vue'
import DSelectUsers from './components/DSelect/DSelectUsers'
import Hello from './components/Hello.vue'
import HoursShow from './components/Hours/HoursShow.vue'
import ListWithSearch from './components/ListWithSearch.vue'
import Login from './components/Login.vue'
import Modal from './components/Modal.vue'
import Notifications from './components/Notifications.vue'
import publicView from './components/public/PublicContainer.vue'
import RecentUsers from './components/RecentUsers.vue'
import SchoolDashboard from './components/School/Dashboard'
import SchoolSidebar from './components/Sidebars/SchoolSideMenu.vue'
import SendSMS from './components/SMS/sms'
import SetupWidget from './components/onboarding/SetupWidget'
import SetupWidgetArrowVacationDay from './components/onboarding/OnboardArrowVacationDaySelector'
import SideNav from './components/SideNav.vue'
import Subs from './components/Subs/Subs'
import tagging from './components/Tagging/Tagging'
import TimeChanger from './components/TimeChanger.vue'
import TlTest from './components/TlTest.vue'
import toasts from './components/toast/Manager.vue'
import UserPresence from './components/Presence/User/PresenceUser.vue'
import VacationDaysSelector from './components/VacationDaysSelector/VacationDaysSelector.vue'
import VideoGuides from './components/onboarding/VideoGuides.vue'
import DoYouTube from './components/YouTube/DoYouTube'
import EventChanges from './components/Log/EventChanges'
import TeamCalendar from './components/TeamCalendar/TeamCalendar'
import BulkCreateSubjects from './components/SubjectsDistribution/BulkCreateSubjects'
import SubjectsDistribution from './components/SubjectsDistribution/SubjectsDistribution'
import QuillOnLesson from './components/Quill/QuillOnLesson'
import DeleteEventOnward from './components/Events/DeleteEventOnward'
import CopyEvent from './components/Events/CopyEvent'
import CopyEventButton from './components/Events/CopyEventButton'
import ExportCalendar from './components/ExportCalendar/ExportCalendar'
import Permissions from './components/Permissions/Permissions'
import UserCalendar from './components/Calendars/CalendarView'
import CalendarsBulk from './components/Calendars/CalendarsBulk'
import Employment from './components/Salary/Employment'
import SalarySubs from './components/Salary/SalarySubsPerf'
import ZenImport from './components/ZenImport/ZenImport'
import CreateCalendars from './components/CreateCalendars/CreateCalendars'
import CreateSubject from './components/Subjects/CreateSubject'
import UserTasks from './components/User/UserTasks'
import TaskOverviewPage from './components/User/TaskOverview/TaskOverviewPage'
import PrintCalendars from './components/PrintCalendars/Print'
import HelpIcon from './components/Help/HelpIcon'
import Students from './components/Students/Students'
import ExternalCalendars from './components/Calendars/ExternalCalendars'
import ImportSubjectsToKlass from './components/Subjects/ImportSubjectsToKlass'
import SubOverviewToday from './components/Subs/OverviewToday'
import SendMessages from './components/SMS/SendMessages'
import AnnualNorm from './components/AnnualNorm/AnnualNorm'
import DProfile from './components/Profile/Profile'
import DShowEventFullCal from './components/Events/DShowEventFullCal'
import DCalendarHeader from './components/DCalendar/DCalendarHeader'
import DoCalendar from './components/Calendars/DoCalendar'
import Arbeidstidsplan from './components/Arbeidsplan/Arbeidsplan.vue'
import BasisOverview from './components/BasisPrimary/BasisOverview.vue'
import DutySchedule from './components/DutySchedule/DutySchedule.vue'
import RequestSubjects from './components/SubjectsDistribution/RequestSubjects.vue'
import AbsenceReasons from './components/AbsenceReasons/AbsenceReasons.vue'
import Reductions from './components/Reductions/Reductions.vue'
import Supplements from './components/Supplements/Supplements.vue'
import UserRequestList from './components/UserRequests/UserRequestList.vue'
import Salary from './components/Salary/Salary.vue'
import SpecialDays from './components/SpecialDays/SpecialDays.vue'
import SchoolUsers from './components/SchoolUsers/SchoolUsers.vue'
import HelpDesk from './components/Helpdesk/Helpdesk.vue'
// required for Rails to "see" Vue in global scope
// also remove expose-loader if removing this
// also remove 'expose' in webpack.base.conf.js if removing this
require('expose?Vue!vue')

Vue.component('assign-users-hours', assignUsersHours)
Vue.component('buy', Buy)
Vue.component('color-picker', ColorPicker)
Vue.component('copy-calendar', copyCalendar)
Vue.component('copy-calendar', copyCalendar)
Vue.component('create-klasses', CreateKlasses)
Vue.component('create-rooms-button', CreateRoomsButton)
Vue.component('create-users', CreateUsers)
Vue.component('create-users-button', CreateUsersButton)
Vue.component('create-users-button-ror', CreateUsersButtonROR)
Vue.component('d-select-users', DSelectUsers)
Vue.component('delete-day-or-week', DeleteDayOrWeek)
Vue.component('delete-user-settings', deleteUserSettings)
Vue.component('direct-day-selector', DirectDaySelector)
Vue.component('dropup', DropUp)
Vue.component('hello', Hello)
Vue.component('hours-show', HoursShow)
Vue.component('list-with-search', ListWithSearch)
Vue.component('login', Login)
Vue.component('modal', Modal)
Vue.component('notifications', Notifications)
Vue.component('onboarding-arrow', arrow)
Vue.component('public-view', publicView)
Vue.component('recent-users', RecentUsers)
Vue.component('school-dashboard', SchoolDashboard)
Vue.component('school-sidebar', SchoolSidebar)
Vue.component('send-sms', SendSMS)
Vue.component('setup-widget', SetupWidget)
Vue.component('setup-widget-arrow', SetupWidgetArrowVacationDay)
Vue.component('side-nav', SideNav)
Vue.component('substitution', Subs)
Vue.component('tagging', tagging)
Vue.component('time-changer', TimeChanger)
Vue.component('tl-test', TlTest)
Vue.component('toasts', toasts)
Vue.component('toasts', toasts)
Vue.component('user-presence', UserPresence)
Vue.component('vacation-days-selector', VacationDaysSelector)
Vue.component('video-guides', VideoGuides)
Vue.component('do-youtube', DoYouTube)
Vue.component('event-changes', EventChanges)
Vue.component('team-calendar', TeamCalendar)
Vue.component('bulk-create-subjects', BulkCreateSubjects)
Vue.component('subjects-distribution', SubjectsDistribution)
Vue.component('quill-on-lesson', QuillOnLesson)
Vue.component('delete-event-onward', DeleteEventOnward)
Vue.component('copy-event', CopyEvent)
Vue.component('copy-event-button', CopyEventButton)
Vue.component('export-calendar', ExportCalendar)
Vue.component('permissions', Permissions)
Vue.component('user-calendar', UserCalendar)
Vue.component('calendars-bulk', CalendarsBulk)
Vue.component('employment', Employment)
Vue.component('salary', SalarySubs)
Vue.component('zen-import', ZenImport)
Vue.component('create-calendars', CreateCalendars)
Vue.component('create-subject', CreateSubject)
// "Opgaveoversigt" (/users/:id/tasks) viser den statiske opgaveliste,
// "Timeopgørelse" (/users/:id/hours) viser den fulde timevisning
Vue.component('user-tasks', TaskOverviewPage)
Vue.component('user-hours', UserTasks)
Vue.component('print-calendars', PrintCalendars)
Vue.component('help-icon', HelpIcon)
Vue.component('students', Students)
Vue.component('external-calendars', ExternalCalendars)
Vue.component('import-subjects-to-klass', ImportSubjectsToKlass)
Vue.component('subs-today', SubOverviewToday)
Vue.component('send-messages', SendMessages)
Vue.component('annual-norm', AnnualNorm)
Vue.component('d-profile', DProfile)
Vue.component('d-show-event-full-cal', DShowEventFullCal)
Vue.component('d-cal-header', DCalendarHeader)
Vue.component('do-calendar', DoCalendar)
Vue.component('work-time', Arbeidstidsplan)
Vue.component('basis-overview', BasisOverview)
Vue.component('duty-schedule', DutySchedule)
Vue.component('request-subjects', RequestSubjects)
Vue.component('absences', AbsenceReasons)
Vue.component('subject-reductions', Reductions)
Vue.component('supplements', Supplements)
Vue.component('user-request-list', UserRequestList)
Vue.component('salary-overview', Salary)
Vue.component('special-days', SpecialDays)
Vue.component('school-users', SchoolUsers)
Vue.component('helpdesk', HelpDesk)



// WEBPACK FOOTER //
// ./src/exported-components.js